import { mergeStyles } from '@fluentui/react';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { IRecentCompaniesCardItem } from '../../utils/types/IRecentCompaniesCardItem';
import { LocalStorageKeys } from '../../utils/hooks/UseLocalStorage';
import GlobeSvg from '../common/svgs/GlobeSvg';
import InsightCard from './InsightCard';
import legacyCompaniesCardContent from './LegacyCompanyCard';
import ListItem from './ListItem';
import { MessagingColors } from '../../app/common/styles/CommonStyleObjects';
import UserContext from '../../utils/authorization/UserContext';
import { StatUser } from '../../utils/statApi/UsersApi';
import hasAccess from '../../utils/authorization/authorizationCheck';

const listStyle = mergeStyles({
  paddingLeft: 0,
});

const RecentCompaniesCard = (): JSX.Element => {
  const companiesString: string = localStorage.getItem(LocalStorageKeys.recentCompanies);
  const companiesList: IRecentCompaniesCardItem[] = JSON.parse(companiesString);
  const user = useContext(UserContext) as unknown as StatUser;
  const canViewFiscalYears = hasAccess(user?.permissions, 'FiscalYearSummaryList:View');
  const canViewProcesses = hasAccess(user?.permissions, 'ProcessesList:View');
  let recentCompaniesCardContent: JSX.Element = <></>;

  const getSubText = (company: { companyCode: string }): JSX.Element => {
    const subTextLinks: JSX.Element[] = [];
    if (canViewFiscalYears) {
      subTextLinks.push(
        <Link key="fiscal-years" to={`/companies/${company.companyCode}/fiscal-years`}>
          Fiscal Year Summary
        </Link>,
      );
    }
    subTextLinks.push(
      <Link key="service-contacts" to={`/companies/${company.companyCode}/service-contacts`}>
        Service Contacts
      </Link>,
    );
    if (canViewProcesses) {
      subTextLinks.push(
        <Link key="processes" to={`/companies/${company.companyCode}/processes`}>
          Processes
        </Link>,
      );
    }
    return (
      <>
        {subTextLinks.map((link, index) => (
          <React.Fragment key={link.key}>
            {index > 0 && ' | '}
            {link}
          </React.Fragment>
        ))}
      </>
    );
  };
  if (companiesList !== null && companiesList?.length > 0) {
    recentCompaniesCardContent = (
      <ul className={listStyle}>
        {companiesList?.map((company) => {
          return (
            <ListItem
              key={company.companyCode}
              title={`${company.companyCode} - ${company.sapName}`}
              sideColor={MessagingColors.successIcon}
              subText={getSubText(company)}
            />
          );
        })}
      </ul>
    );
  } else {
    recentCompaniesCardContent = legacyCompaniesCardContent;
  }
  return (
    <InsightCard
      caption="Recent Companies"
      mainText={recentCompaniesCardContent}
      footerLink={<Link to="/companies">Go to Company &#38; Process Management</Link>}
      svgComponent={<GlobeSvg />}
    />
  );
};

export default RecentCompaniesCard;
